import React from "react";
import { type Answer } from "features/Library/Assessments/types/state";
import { type AnswerPropsBase } from "features/Library/Common/QuestionsForm/types";
import { TextAnswer } from "features/Library/Common/QuestionsForm/Answers/AnswerFields/TextAnswer";

export type MultipleTextAnswerProps = AnswerPropsBase<Answer>;

export const AssessmentMultipleTextAnswer = (props: MultipleTextAnswerProps) => {
  const { index, answer, propertyNamePrefix, onBlur, onChanged, disabled, validatedFieldProps } = props;

  const answerFieldPropertyName = `${propertyNamePrefix}answers.${index}.answer.text`;
  const checkboxFieldPropertyName = `${propertyNamePrefix}answers.${index}.answer.isCorrect`;

  return (
    <TextAnswer
      answerFieldPropertyName={answerFieldPropertyName}
      checkboxFieldPropertyName={checkboxFieldPropertyName}
      answer={answer.answer.text}
      isChecked={answer.answer.isCorrect}
      index={index}
      onChanged={onChanged}
      onBlur={onBlur}
      disabled={disabled}
      validatedFieldProps={validatedFieldProps}
      pathToValidate={`${propertyNamePrefix}answers`}
    />
  );
};
